@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <app-documentation-tree [nodes]="documentationNodes()" [expanded]="true" (downloadRequested)="download($event)"></app-documentation-tree>
  <app-documentation-tree [nodes]="revitFileNodes()" [expanded]="false" (downloadRequested)="downloadRevit($event)"></app-documentation-tree>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
